export const coach = {
    categories: [],
    get schema() {
        return {
            title: 'Coach',
            type: 'object',
            properties: {
                name: {
                    title: 'Name',
                    type: 'string',
                },
                salesforceId: {
                    title: 'SalesForce ID',
                    type: 'string',
                },
                firstName: {
                    title: 'First Name',
                    type: 'string',
                },
                lastName: {
                    title: 'Last Name',
                    type: 'string',
                },
                designation: {
                    title: 'Designation',
                    type: 'string',
                },
                experience: {
                    title: 'Experience (insert the year they became a coach e.g. 2010)',
                    type: 'string',
                },
                story: {
                    title: 'Story',
                    type: 'string',
                    format: 'textarea',
                },
                linkedin: {
                    title: 'Linkedin',
                    type: 'string',
                },
                twitter: {
                    title: 'Twitter',
                    type: 'string',
                },
                video: {
                    title: 'Video',
                    type: 'string',
                },
                specialty: {
                    title: 'Specialty',
                    type: 'array',
                    items: {
                        type: 'object',
                        title: 'Specialty Entry',
                        properties: {
                            title: {
                                title: 'Title',
                                type: 'string',
                                enum: [
                                    ...new Set([''].concat(this.categories
                                        .filter((a) => a.type === 'category' &&
                                        a.region === 'us' &&
                                        a.language === 'en' &&
                                        a.parentId === '')
                                        .map((a) => a.title)
                                        .sort())),
                                ],
                            },
                            slug: {
                                title: 'Slug',
                                type: 'string',
                                options: {
                                    inputAttributes: {
                                        class: 'disabled',
                                    },
                                },
                            },
                        },
                    },
                },
                education: {
                    title: 'Education',
                    type: 'array',
                    items: {
                        title: 'Education Entry',
                        type: 'string',
                    },
                },
            },
        };
    },
};
//# sourceMappingURL=coachJsonEditorConfig.js.map